import React, { Component } from 'react';

import { getCharFilename } from './Utils.js';

class Character extends Component {
    static defaultProps = { x:0, y:0, size:50, team:"gray" };

    render() {
        return (
            <g>
              <image href={getCharFilename(this.props.character, this.props.alt, this.props.team)} width={this.props.size} height={this.props.size} x={this.props.x} y={this.props.y} />
            </g>
        );
    }
}


export default Character;
